import React from "react";
import MobileMockup from "../illustrations/MobileMockup";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden pb-0">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-10 py-16 relative">
        <div className="grid items-center gap-10 md:grid-cols-2">
          <div className="text-center md:text-left intro-seq-hero from-left" data-reveal style={{ ['--reveal-delay' as any]: '300ms', ['--reveal-distance' as any]: '60px', ['--reveal-duration' as any]: '1080ms', ['--reveal-ease' as any]: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }}>
            <h1 className="hero-title text-4xl font-semibold sm:text-6xl md:text-5xl lg:text-6xl">
              Seamless POS for Solana Payments
            </h1>
            <p className="hero-lead mx-auto md:mx-0 mt-6 max-w-2xl text-neutral-300 sm:text-lg">
              Accept Solana payments effortlessly with QR codes and a streamlined checkout process.
            </p>
            <div className="hero-buttons mt-8 flex justify-center md:justify-start gap-4">
              <a href="/docs/" className="rounded-md bg-indigo-600 px-4 py-2 font-medium text-white hover:bg-indigo-500">Read the Docs</a>
              <a href="#features" className="rounded-md border border-neutral-700 px-4 py-2 font-medium text-white hover:bg-neutral-800">Explore Features</a>
            </div>
            <p className="mt-4 text-sm text-neutral-400 intro-seq-hero">
            Payme.sol is a fully decentralized application that requires no personal information, subscriptions, or user data to operate. Anyone can use it freely, at their own responsibility.
            </p>
          </div>
          <div className="hero-mockup relative flex items-center justify-center md:justify-end from-right" data-reveal style={{ ['--reveal-delay' as any]: '480ms', ['--reveal-distance' as any]: '56px', ['--reveal-duration' as any]: '1080ms', ['--reveal-ease' as any]: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }}>
            <MobileMockup
              className="w-full will-change-transform transform-gpu max-w-[190px] sm:animate-float sm:max-w-[190px] md:max-w-[210px] lg:max-w-[240px]"
              imageSrc="/assets/pro.png"
              imageAlt="Payme.sol Pro app preview"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
